import styled from 'styled-components'

import { fromLg, fromMd } from '@syconium/little-miss-figgy'
import { Dialog, ResponsiveImage } from '@syconium/little-miss-figgy/dist/components'

export const GalleryWrap = styled.div`
  padding: ${o => o.theme.spacing(2, 0, 4, 0)};
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${o => o.theme.spacing(2)};

  ${fromMd} {
    grid-template-columns: repeat(5, 1fr);
    row-gap: ${o => o.theme.spacing(4)};
  }
`

export const DialogContent = styled.div`
  padding: ${o => o.theme.spacing(4)};

  ${fromMd} {
    padding: ${o => o.theme.spacing(6, 10)};
    overflow-y: auto;
    max-height: 70vh;
  }
`

export const TileName = styled.div`
  padding-top: ${o => o.theme.spacing(2)};
  line-height: 22px;
`

export const Tile = styled(ResponsiveImage)`
  box-sizing: border-box;
  cursor: pointer;
  border: 1px solid ${o => o.theme.color.stroke.neutral.text.highContrast.on.dark};
  transition: border-color 0.3s;

  &:hover {
    border: 1px solid ${o => o.theme.color.stroke.neutral.text.primary.on.background};
  }
`

export const ModalTitleWrap = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 27px;

  ${fromMd} {
    flex-direction: row;
    align-items: flex-end;
    padding: ${o => o.theme.spacing(2, 6)};
  }
`

export const ColorCount = styled.div`
  ${fromMd} {
    margin-left: ${o => o.theme.spacing(4)};
    flex: none;
    padding-bottom: ${o => o.theme.spacing(0.5)};
  }
`

export const DialogHeader = styled.span`
  font-size: ${o => o.theme.typography.font.size[17]};

  ${fromMd} {
    font-size: ${o => o.theme.typography.font.size[28]};
  }
`

export const DialogTitle = styled(Dialog.Title)`
  text-transform: capitalize;
`

export const PillText = styled.span`
  margin-left: ${o => o.theme.spacing(1)};
  letter-spacing: ${o => o.theme.typography.font.letterSpacing.medium};
`

export const OptionalWord = styled.span`
  display: none;

  ${fromLg} {
    display: inline-block;
  }
`

export const LoadingSpinnerWrapper = styled.div`
  padding: ${o => o.theme.spacing(10)};
  display: flex;
  justify-content: center;
`

export const DialogModal = styled(Dialog.Modal)`
  ${fromMd} {
    max-width: 1030px;
    width: 1030px;
  }
`
